import { Button, Group, Paper, type ComboboxItem } from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';
import { type ReactElement, useEffect, useState } from 'react';

interface Props {
  navigationOptions: ComboboxItem[];
  addons?: ReactElement[];
  sectionUrlIndex: number;
  removeSearchParams?: boolean;
}

export const SectionSelector = (props: Props): JSX.Element => {
  const { navigationOptions, addons, sectionUrlIndex, removeSearchParams } =
    props;
  const location = useLocation();

  function getSection(index: number) {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    if (index < pathSegments.length) {
      return pathSegments[index];
    }
    return '';
  }

  const [selectedSection, setSelectedSection] = useState<string>(
      getSection(sectionUrlIndex)
  );

  useEffect(() => {
    setSelectedSection(getSection(sectionUrlIndex));
  }, [location]);

  return (
      <Paper withBorder radius="md" className="p-4">
        <Group className="justify-between">
          <Group>
            {navigationOptions.map(navOption => (
                <Link
                    key={navOption.value}
                    to={`${navOption.value}${removeSearchParams ? '' : location.search}`}
                >
                  <Button
                      onClick={() => {
                        setSelectedSection(navOption.value);
                      }}
                      className={`${
                          selectedSection === navOption.value
                              ? 'text-primary'
                              : 'text-section-inactive'
                      }  hover:text-primary`}
                      key={navOption.value}
                      variant={
                        selectedSection === navOption.value ? 'light' : 'subtle'
                      }
                  >
                    {navOption.label}
                  </Button>
                </Link>
            ))}
          </Group>
          <Group>
            {addons?.map((addon, index) => (
                <div key={index}>{addon}</div>
            ))}
          </Group>
        </Group>
      </Paper>
  );
};